module.exports = __webpack_public_path__ + "img/gl.c6090a99.svg";